/* eslint-disable */
/**
 * @file 微视 Schema 模块
 */
import { WSClipboard } from '@tencent/wesee-clipboard';
import {
  util, browser, schema, msg,
} from '../ws-hybrid';
import { pageInfo } from '../ws-common';
import SCHEMA_CONST from './schema.const';
import schemaBase from './schema.base';
// import superDownload from '../superdownload/src/index';
import comUI from '../ws-common/ui';
import load from '../ws-util/load';

// const wsClipboardSdk = 'https://isee.weishi.qq.com/iseecdn/static/js/split/ws-clipboard.js';
// window.openDownloadApp = superDownload;

// 不同渠道的安装包
const { iosSetupUrl } = SCHEMA_CONST;
// const { APPID } = SCHEMA_CONST;
const {
  PACKAGE_NAME,
  SUPER_DOWNLOAD,
  androidPackageCfg,
  androidPackageClientCfg,
} = SCHEMA_CONST;
let packageId;
// eslint-disable-next-line no-unused-vars
let androidSetupUrl;

const getChid = () => (
  parseInt(window.__INITIAL_STATE__ && window.__INITIAL_STATE__.chid)
    || parseInt(window.syncData && window.syncData.chid)
    || util.getUrlParam('chid')
);

const getPkg = () => (
  parseInt(window.__INITIAL_STATE__ && window.__INITIAL_STATE__.pkgId)
    || parseInt(window.syncData && window.syncData.pkgId)
    || parseInt(util.getUrlParam('pkgid'))
    || parseInt(util.getUrlParam('pkg'))
);

/**
 * 微视 Schema 类
 * @class WsSchema
 */
class WsSchema extends schemaBase {
  constructor() {
    super();
    /**
     * @type {Object}
     */
    this.openDownloadApp = {
      load: this.load.bind(this),
      start: this.start.bind(this),
      preloadPkgId: this._preloadPkgId.bind(this),
    };
  }

  /**
   * 加载超级下载器
   * @method
   */
  load() {
    return new Promise((resolve, reject) => {
      // 新版的superdownload检查到define后，就不会往window添加openDownloadApp变量
      if (window.openDownloadApp) {
        const { openDownloadApp } = window;
        if (openDownloadApp.setSource) {
          openDownloadApp.setSource({ isWeishi: true });
        } else {
          console.warn('superdownload still old');
        }
        // superdownload 下载完成触发event
        if (!window.hasloadedOpenDownloadApp) {
          console.log('set newEvent onSuperDownloadReady');
          const event = new Event('onSuperDownloadReady');
          document.dispatchEvent(event);
          window.hasloadedOpenDownloadApp = true;
        }
        resolve(openDownloadApp);
      } else {
        load.loadJs(SUPER_DOWNLOAD, () => {
          if (window.openDownloadApp) {
            const { openDownloadApp } = window;
            if (openDownloadApp) {
              console.log('set source');
              if (openDownloadApp.setSource) {
                openDownloadApp.setSource({ isWeishi: true });
              } else {
                console.warn('superdownload still old');
              }
              // superdownload 下载完成触发event
              if (!window.hasloadedOpenDownloadApp) {
                console.log('set newEvent onSuperDownloadReady');
                const event = new Event('onSuperDownloadReady');
                document.dispatchEvent(event);
                window.hasloadedOpenDownloadApp = true;
              }
              resolve(openDownloadApp);
            } else {
              reject();
            }
          } else {
            console.error('load superdownload fail');
          }
        });
      }
    });
  }

  /**
   * 开始下载
   * @param {Object} params
   * @method
   */
  async start(params) {
    const data = Object.assign(
      {},
      {
        pkgId: packageId,
      },
      params,
    );
    console.log(data);
    if (data.schema) {
      data.schema = this.addLogSour(data.schema);
      // 增加channelid ，应用宝用，增加yybchid字段
      data.channelId = util.getUrlParam('yybchid') || '000116083734363233323931';
      await this.load();
      if (window.openDownloadApp) {
        window.openDownloadApp.start(data);
      }
    }
  }

  async _preloadPkgId(pkgId) {
    const newPkgId = pkgId || packageId;
    await this.load();
    if (window.openDownloadApp) {
      window.openDownloadApp.preloadPkgId(newPkgId);
    }
  }

  /**
   * 初始化下载器
   * @method
   */
  autoInit() {
    if (!window.document) {
      // 只有异步走这个逻辑
      return;
    }
    // 顺序：node指定->chid参数->pkg参数->各种默认值
    packageId = getChid()
      || getPkg()
      || androidPackageCfg[pageInfo.pageFrom]
      || androidPackageClientCfg[browser.client]
      || '';
    androidSetupUrl = `https://mobile.qzone.qq.com/l?g=${packageId}`; // 据说这个已经没用了，所以packageId访问child

    setTimeout(() => {
      this.preloadPkgId();
    }, 0);
  }

  /**
   * 预加载下载包
   * @param {String|Number} pkgId 包 id
   * @method
   */
  preloadPkgId(pkgId) {
    if (browser.client === 'qq' || browser.client === 'wx') {
      this._preloadPkgId(pkgId);
    }
  }

  /*
    这几个移到基类schema.base.js里了，调用方式不变
    canOpenSchema
    addLogSour
    pingSchema
    formatSchema
    formatUrl
  */

  /**
   * 吊起schema，未安装微视支持跳转下载或者跳转指定页面
   * @param {String} schema_ 可以是完整的schema，但是建议是简化的，组件帮你拼，详见pingSchema方法
   * @param {Object} option 非必须
   * @param {String} option.jumpUrl 指定未下载的跳转页面，非必须，不指定的话会调整下载页
   * @param {String} option.jumpTarget 非必须，指当前页打开或者新开页面打开
   * @param {String} option.jumpDelay 跳转间隔，默认800ms
   * @param {Boolean} option.needDownload 是否跳转之后下载，默认为true
   * @method
   */
  openSchema(schema_, option) {
    const opt = Object.assign({
      jumpUrl: '',
      jumpTarget: 1,
      jumpDelay: 800,
      needDownload: true,
    }, option);

    if (opt.clipboard) {
      WSClipboard.write(schema_, opt.clipboardCb
        ? opt.clipboardCb
        : () => {
          console.log('write clipboard success: ', schema_);
        });
      // can't async load sdk, write fail in no api platform
      // if (window.WSClipboard) {
      //   window.WSClipboard.write(schema_, opt.clipboardCb
      //     ? opt.clipboardCb
      //     : () => { console.log('write clipboard success: ', schema_); });
      // } else {
      //   load.loadJs(wsClipboardSdk, () => {
      //     window.WSClipboard.write(schema_, opt.clipboardCb
      //       ? opt.clipboardCb
      //       : () => { console.log('write clipboard success: ', schema_); });
      //   });
      // }
    }

    if (opt.jumpUrl) {
      // 有这个就不下载了
      opt.needDownload = false;
    }

    // 处理schema
    // eslint-disable-next-line no-param-reassign
    schema_ = this.formatSchema(schema_, opt);

    // 处理一下jumpUrl
    if (opt.jumpUrl) {
      // 如果是跳转play页面就要跳相应聚合页的播放页，检查是否play页移到formatUrl里去了
      opt.jumpUrl = schemaBase.formatUrl(opt.jumpUrl, opt);
    }

    // TODO上报

    if (!browser.isMobile) {
      if (window.logger) {
        window.logger.log('openSchema in pc');
      }

      // pc端的，直接跳转或者出二维码
      if (opt.jumpUrl) {
        if (window.logger) {
          window.logger.log('openSchema in pc with jumpUrl');
        }
        this.openUrl(opt.jumpUrl, {
          target: opt.jumpTarget,
        });
      } else {
        if (window.logger) {
          window.logger.log('openSchema in pc with qrcode');
        }
        comUI.showQRCode();
      }
      return;
    }

    if (browser.client === 'ws') {
      if (window.logger) {
        window.logger.log('openSchema in ws');
      }
      // 微视客户端内，直接setLocation
      schema.setLocation(schema_);
      return;
    } else {
      schema_ = this.addXlightFlag(schema_);
    }

    if (browser.client === 'wb') {
      if (window.logger) {
        window.logger.log('openSchema in wb');
      }
      // 微博客户端内，去掉引导打开浏览器去跳转的浮层，自动唤起浏览器/app store拉新
      if (browser.platform === 'ios') {
        !opt.itunesUrl && (opt.itunesUrl = iosSetupUrl);
      }
      // comUI.showSchemeTip(schema_);
      // return;
    }

    if ((browser.client === 'qzone' || browser.client === 'qq')
      && browser.platform === 'android'
      && opt.jumpUrl
      && /^https?:\/\/h5.qzone.qq.com\/weishi\//.test(opt.jumpUrl)
    ) {
      // 手空安卓独立版直接开打jumpUrl，在新页面处理schema
      if (window.logger) {
        window.logger.log('openSchema in qq qzone with jumpUrl');
      }

      this.openUrl(
        `${opt.jumpUrl}#openschema=${encodeURIComponent(schema)}`,
        {
          target: opt.jumpTarget,
        },
      );
      return;
    }
    if (window.logger) {
      window.logger.log('openSchema openDownloadApp');
    }

    if (opt.needDownload) {
      document.addEventListener('superDownload_weishi_inqq', () => {
        msg.show('正在下载微视');
      });
      console.log('this.openDownloadApp.start schema', schema_);
      this.openDownloadApp.start({
        ...opt,
        schema: schema_,
      });
    } else {
      // 直接打开schema然后调整jumpUrl吧;
      schema.setLocation(schema_);
      if (opt.jumpUrl) {
        setTimeout(() => {
          this.openUrl(opt.jumpUrl, {
            target: opt.jumpTarget,
          });
        }, opt.jumpDelay);
      }
    }
  }

  /**
   * 各端打开链接
   * @param {String} url url
   * @param {Object} option option
   * @method
   */
  openUrl(url, option) {
    if (!url) {
      return;
    }
    const opt = option || {};
    opt.target = parseInt(opt.target);
    // eslint-disable-next-line no-restricted-properties
    if (window.isNaN(opt.target)) {
      // 默认新开
      opt.target = 1;
    }
    if (browser.client === 'ws') {
      // 微视客户端内
      if (opt.target) {
        this.openSchema('webview', {
          jump_url: url,
        });
      } else {
        window.location.href = url;
      }
    } else if (browser.client === 'qzone') {
      if (window.mqq) {
        window.mqq.invoke('ui', 'openUrl', {
          url,
          target: opt.target,
        });
      }
    } else if (browser.client === 'qq') {
      if (window.mqq) {
        window.mqq.ui.openUrl({
          url,
          target: opt.target,
        });
      }
    } else if (opt.target) {
      window.open(url);
    } else if (browser.isMobile) {
      window.location.href = url;
    } else {
      window.top.location.href = url;
    }
  }

  /**
   * 设置包 id
   * @param {Number|String} pkgId
   * @method
   */
  setPackageId(pkgId) {
    const _pkgId = parseInt(pkgId);
    if (_pkgId) {
      packageId = _pkgId;
      androidSetupUrl = `https://mobile.qzone.qq.com/l?g=${packageId}`;

      this.preloadPkgId();
    }
  }

  /**
   * 根据当前 url 自动打开 APP 相关页面
   * @method
   */
  smartOpenApp() {
    const _temp = this.smartGenerateSchema();
    this.openSchema(_temp.schema, _temp.opts);
  }

  /**
   * 自动识别 schema
   * @method
   */
  smartGenerateSchema() {
    const methodList = [
      'feed',
      'topic',
      'music',
      'geo',
      'personal',
      // 'personality',
      'acttogether',
    ];
    const optionList = [
      'feed_id',
      'topic_id',
      'music_id',
      'geo_id',
      'person_id',
      // 'person_id',
      'polyId',
    ];
    const path = window.location.pathname;
    const index = methodList.findIndex(o => ~path.indexOf(o));
    const method = methodList[index];
    const optkey = optionList[index];
    if (method) {
      const id = path
        .slice(path.indexOf(method) + method.length + 1)
        .split('/')[0]
        .replace(/\//g, '');
      const schema_ = id ? method : 'recommend';
      const opts = optkey
        ? {
          [optkey]: id,
        }
        : {};
      return {
        schema: schema_,
        opts,
      };
    }
    return {
      schema: 'recommend',
    };
  }

  /**
   * 检测是否安装 QQ，注意需要使用 qqapi(qq.oa.com)
   * @param {Function} cb
   * @method
   */
  isWsInstalledInQQ(cb) {
    return new Promise(((resolve, reject) => {
      if (browser.client === 'qq' && window.mqq) {
        window.mqq.app.isAppInstalled(
          browser.platform === 'android' ? PACKAGE_NAME : 'weishi',
          (isInstall) => {
            if (isInstall) {
              resolve(true);
              if (typeof cb === 'function') {
                cb(null, 'yes');
              }
            } else {
              resolve(false);
              if (typeof cb === 'function') {
                cb(null, 'no');
              }
            }
          },
        );
      } else {
        // 如果使用了回调方式的话，则不reject,因为会抛错
        // eslint-disable-next-line no-lonely-if
        if (typeof cb === 'function') {
          cb('unknow');
        } else {
          // eslint-disable-next-line prefer-promise-reject-errors
          reject('unknow');
        }
      }
    }));
  }

  /**
   * @description 关闭页面
   * @param {Object} opt
   * @param {boolean} opt.closeAll true关闭所有的webview,false关闭当前的webview
   * @method
   * */
  closeWebview(opt = {}) {
    if (!window.mqq) return;
    const close = () => {
      if (opt.closeAll) {
        if (browser.client === 'ws') {
          window.mqq.invoke('ui', 'popBack');
        } else if (window.mqq) {
          window.mqq.invoke('ui', 'closeWebViews');
        }
      } else {
        // 关闭当前
        // eslint-disable-next-line no-lonely-if
        if (browser.client === 'ws') {
          if (window.mqq) {
            window.mqq.invoke('ui', 'popBack');
          }
        } else if (browser.client === 'qzone') {
          if (browser.platform === 'ios') {
            if (window.mqq) {
              window.mqq.invoke('system', 'closeWebview');
            }
          } else if (window.QZAppExternal) {
            window.QZAppExternal.closeWebview();
          }
        } else {
          window.mqq.invoke('ui', 'popBack');
        }
      }
    };

    setTimeout(close, opt.delay || 0);
  }
}

export default new WsSchema();
